import React, { Component } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,InputAdornment,
  TablePagination, TextField, Collapse, Alert, IconButton, Box, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from 'axios';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';

export default class Serviceprovidermanagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceData: [],
      serviceList: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,searchText: '',
  selectedService: '',
      itemsPerPageOptions: [5, 10, 20],
    };
    this.dialogRef = React.createRef();
  }

  componentDidMount() {
	   document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchServiceProviders();
    this.fetchServiceList();
  }

fetchServiceProviders = () => {
  const { page, rowsPerPage, searchText, selectedService } = this.state;

  const params = {
    page,
    limit: rowsPerPage,
    ...(searchText && { search: searchText }),
    ...(selectedService && { serviceId: selectedService }),
  };

  axios.get(Serverurl+"serviceprovider/serviceprovidergetall", { params })
    .then(res => {
      const { data, totalItems } = res.data;
      this.setState({ serviceData: data, totalItems });
    });
};

  fetchServiceList = () => {
    axios.get(Serverurl+"servicemanagement/servicemanagementselect")
      .then(res => this.setState({ serviceList: res.data }));
  };

  handleDelete = (sp_id) => {
    confirmAlert({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this service provider?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => axios.delete(`${Serverurl}serviceprovider/serviceproviderdelete/${sp_id}`)
            .then(this.fetchServiceProviders)
        },
        { label: 'No' }
      ]
    });
  };

  handleOpenDialog = (service = null) => {
    this.dialogRef.current?.openDialog(service);
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchServiceProviders);
  };

  handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRows, page: 0 }, this.fetchServiceProviders);
  };

  render() {
    if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 

    return (
      <Box>
	   <div className="maincontentDiv">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography className="contentHeading" variant="h5">Service Providers</Typography>
          <Button style={{
    marginRight: '20px',
    marginTop: '15px'
}}
variant="contained" className="frmPrimarybtn" onClick={() => this.handleOpenDialog()} startIcon={<AddIcon />}>
            Add
          </Button>
        </Box>

        <ServiceDialog
          ref={this.dialogRef}
          serviceList={this.state.serviceList}
          onSuccess={this.fetchServiceProviders}
        />
		<Box
  sx={{
    display: "flex",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
    alignItems: "center"
  }}
>
<Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", width: "230px"  }}>
    <Typography variant="body1">Name / Email / Mobile</Typography>
  <TextField
placeholder="Search"
    size="small"
    value={this.state.searchText}
    onChange={e => this.setState({ searchText: e.target.value, page: 0 })}
  InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <img
            src={searchIcon} 
            alt="Search"           
          />
        </InputAdornment>
      ),
    }}
	/>
 </Box>
 
  <Box sx={{ display: "flex", flexDirection: "column", width: "230px"  }}>
    <Typography variant="body1">Service</Typography>
  <TextField
    select
    variant="outlined"
    size="small"
    value={this.state.selectedService}
    onChange={e => this.setState({ selectedService: e.target.value, page: 0 })}
    SelectProps={{ native: true }}
  >
      <Typography variant="body1">Services</Typography>
    <option value="">All</option>
    {this.state.serviceList.map(service => (
      <option key={service.sm_id} value={service.sm_id}>{service.sm_title}</option>
    ))}
  </TextField>
  </Box>
  <Button 
  size="small"
variant="contained"
    className="frmPrimarybtn"
    sx={{marginTop:3}}	 onClick={() => this.fetchServiceProviders()}>Search</Button>
</Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Service</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.serviceData.length > 0 ? this.state.serviceData.map((service, index) => (
                <TableRow key={index}>
                  <TableCell>{service.sp_name}</TableCell>
                  <TableCell>{service.sp_emailid}</TableCell>
                  <TableCell>{service.sp_phonenumber}</TableCell>
                  <TableCell>{service.sp_address}</TableCell>
                  <TableCell>{service.servicemanagement.sm_title}</TableCell>
                  <TableCell>
                    <Button variant="contained" size="small" className="frmPrimarybtn" onClick={() => this.handleOpenDialog(service)} endIcon={<EditIcon />}>Edit</Button>
                    <Button size="small" variant="contained" className="frmSecondarybtn" onClick={() => this.handleDelete(service.sp_id)} style={{ marginLeft: 8 }} endIcon={<DeleteIcon />}>Delete</Button>
                  </TableCell>
                </TableRow>
              )) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">No service provider records found.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={this.state.itemsPerPageOptions}
          />
        </TableContainer></div>
      </Box>
    );
  }
}




class ServiceDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isEditing: false,
      sp_id: '',
      sp_name: '',
      sp_emailid: '',
      sp_phonenumber: '',
      sp_address: '',
      sp_sm_id: '',
      errormessage: '',
      validationErrors: {},
      errorOpen: false,
    };
  }

  openDialog = (service = null) => {
    if (service) {
      this.setState({
        open: true,
        isEditing: true,
        sp_id: service.sp_id,
        sp_name: service.sp_name,
        sp_emailid: service.sp_emailid,
        sp_phonenumber: service.sp_phonenumber || '',
        sp_address: service.sp_address,
        sp_sm_id: service.sp_sm_id,
        validationErrors: {},
        errormessage: '',
        errorOpen: false
      });
    } else {
      this.setState({
        open: true,
        isEditing: false,
        sp_id: null,
        sp_name: '',
        sp_emailid: '',
        sp_phonenumber: '',
        sp_address: '',
        sp_sm_id: '',
        validationErrors: {},
        errormessage: '',
        errorOpen: false
      });
    }
  };

  handleClose = () => {
    this.setState({ open: false, errorOpen: false });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'sp_phonenumber') {
      this.setState({ [name]: value.replace(/\D/g, '') });
    } else {
      this.setState({ [name]: value });
    }
  };

  validateForm = () => {
    const errors = {};
    const { sp_name, sp_emailid, sp_phonenumber, sp_address, sp_sm_id } = this.state;
    if (!sp_name.trim()) errors.sp_name = 'Name is required';
    if (!sp_emailid.trim()) errors.sp_emailid = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(sp_emailid)) errors.sp_emailid = 'Invalid email';
   if (!String(this.state.cu_phonenumber).trim())  errors.sp_phonenumber = 'Phone required';
    else if (!/^\d{10}$/.test(sp_phonenumber)) errors.sp_phonenumber = 'Phone must be 10 digits';
    if (!sp_address.trim()) errors.sp_address = 'Address is required';
    if (!sp_sm_id) errors.sp_sm_id = 'Select service';

    if (Object.keys(errors).length) {
      const firstError = Object.values(errors)[0];
      this.setState({ validationErrors: errors, errormessage: firstError, errorOpen: true });
      return false;
    }
    this.setState({ validationErrors: {}, errormessage: '', errorOpen: false });
    return true;
  };

  handleSubmit = () => {
    if (!this.validateForm()) return;

    const { sp_name, sp_emailid, sp_phonenumber, sp_address, sp_sm_id, isEditing, sp_id } = this.state;
    const data = { sp_name, sp_emailid, sp_phonenumber, sp_address, sp_sm_id };

let request;
if(isEditing){
      request =axios.put(`${Serverurl}serviceprovider/serviceproviderupdate/${sp_id}`, data);
}else{
      request =axios.post(Serverurl+"serviceprovider/serviceproviderinsert", data);
}
    request.then(() => {
      this.props.onSuccess();
      this.handleClose();
    });
  };

  render() {
    const { open, sp_name, sp_emailid, sp_phonenumber, sp_address, sp_sm_id, errorOpen, errormessage } = this.state;
    const { serviceList } = this.props;

    return (
      <Dialog open={open} onClose={this.handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{this.state.isEditing ? 'Service Provider' : 'Service Provider'}</DialogTitle>
        <DialogContent>
          <Collapse in={errorOpen}>
            <Alert
              severity="error"
              action={<IconButton onClick={() => this.setState({ errorOpen: false })}><CloseIcon /></IconButton>}
              sx={{ mb: 2 }}
            >
              {errormessage}
            </Alert>
          </Collapse>
<p className="serviceProviderTextField">
  Name<span className="validation"> * </span>
</p>
<input
  type="text"
  name="sp_name"
  className="form-control"
  placeholder="Enter name"
  value={sp_name}
  maxLength={150}
  onChange={this.handleInputChange}
/>

<p className="serviceProviderTextField">
  Email<span className="validation"> * </span>
</p>
<input
  type="email"
  name="sp_emailid"
  className="form-control"
  placeholder="Enter Email"
  value={sp_emailid}
  maxLength={150}
  onChange={this.handleInputChange}
/>

<p className="serviceProviderTextField">
  Phone Number<span className="validation"> * </span>
</p>
<input
  type="text"
  name="sp_phonenumber"
  className="form-control"
  placeholder="Enter Phone Number"
  value={sp_phonenumber}
  maxLength={10}
  onChange={this.handleInputChange}
/>

<p className="serviceProviderTextField">
  Address<span className="validation"> * </span>
</p>
<textarea
  name="sp_address"
  className="form-control"
  placeholder="Enter Address"
  rows={2}
  maxLength={150}
  value={sp_address}
  onChange={this.handleInputChange}
/>

<p className="serviceProviderTextField">
  Services<span className="validation"> * </span>
</p>
<select
  name="sp_sm_id"
  className="form-control"
  value={sp_sm_id}
  onChange={this.handleInputChange}
>
  <option value="">Select Service</option>
  {serviceList.map((service) => (
    <option key={service.sm_id} value={service.sm_id}>
      {service.sm_title}
    </option>
  ))}
</select>
        </DialogContent>
       <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button className="frmSecondarybtn" variant="contained" onClick={this.handleClose}>Cancel</Button>
          <Button  className="frmPrimarybtn" variant="contained" onClick={this.handleSubmit}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
